import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { FirebaseProvider } from './firebase/firebase-provider'
import { ServiceWorkerProvider } from './context-providers/use-service-worker'

console.log('main.tsx: Starting app')
console.log('main.tsx: Root element:', document.getElementById('root'))

const rootElement = document.getElementById('root')
if (!rootElement) {
  console.error('main.tsx: Root element not found!')
  throw new Error('Root element not found')
}

console.log('main.tsx: Creating root')
const root = createRoot(rootElement)

console.log('main.tsx: Rendering app')
root.render(
  <StrictMode>
    <ServiceWorkerProvider>
      <FirebaseProvider>
        <App />
      </FirebaseProvider>
    </ServiceWorkerProvider>
  </StrictMode>,
)

console.log('main.tsx: Render call completed')
